"use client";

import useExternalLinks from "~/hooks/use-external-links";

export default function ExternalLinksSync() {
  useExternalLinks();
  return null;
}
